import { Injector } from '@angular/core';
import { FormioCustomComponentInfo, registerCustomFormioComponent } from 'dp-formio';
import { CardWrapperComponent } from './card-wrapper.component';
const COMPONENT_OPTIONS: FormioCustomComponentInfo = {
	type: 'card-wrapper', // custom type. Formio will identify the field with this type.
	selector: 'card-wrapper', // custom selector. Angular Elements will create a custom html tag with this selector
	title: 'card wrapper', // Title of the component
};

export function registerCardWrapperComponent(injector: Injector) {
	registerCustomFormioComponent(COMPONENT_OPTIONS, CardWrapperComponent, injector);
}
